import { createContext } from 'react';
import { Member } from '../interfaces';

export const MemberContext = createContext<Member>(null);
